"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, useInView } from "framer-motion";
import { ArrowDownRight } from "lucide-react";
import Link from "next/link";
import RippleButton from "./animata/button/ripple-button";
// 3D imports are kept for the disabled Canvas block — re-enable when needed
// import { Canvas, useFrame } from "@react-three/fiber";
// import { MeshDistortMaterial } from "@react-three/drei";
/* might need to add useMemo for 3d objects or others */
import { useRef, useEffect, useState } from "react";
// import * as THREE from "three";

// // eslint-disable-next-line @typescript-eslint/no-unused-vars
// function SystemLeak({ isCanvasInView }: { isCanvasInView: boolean }) {
//   const [isEmber, setIsEmber] = useState(false);
//   const [isNeumorphic, setIsNeumorphic] = useState(false);

//   useEffect(() => {
//     const checkTheme = () => {
//       setIsEmber(document.documentElement.classList.contains("theme-color"));
//       setIsNeumorphic(document.documentElement.classList.contains("theme-neumorphic"));
//     };
//     checkTheme();

//     const observer = new MutationObserver(checkTheme);
//     observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

//     return () => observer.disconnect();
//   }, []);

//   const coreRef = useRef<THREE.Mesh>(null);
//   const dropsGroupRef = useRef<THREE.Group>(null);
//   const mouse = useRef({ x: 0, y: 0 });

//   let anomalyColor = "#ffffff";
//   if (isEmber) {
//     anomalyColor = "#FF3300";
//   } else if (isNeumorphic) {
//     anomalyColor = "#3d3426"; // Renders as the Neumorphic shadow color #a3b1c6, turns deep navy over text
//   }

//   const boxGeom = useMemo(() => new THREE.BoxGeometry(1.5, 1.5, 1.5), []);
//   const boxMat = useMemo(() => new THREE.MeshBasicMaterial({ color: anomalyColor }), [anomalyColor]);

//   useEffect(() => {
//     return () => {
//       boxGeom.dispose();
//     };
//   }, [boxGeom]);

//   useEffect(() => {
//     return () => {
//       boxMat.dispose();
//     };
//   }, [boxMat]);

//   const [dropsData] = useState(() => {
//     return Array.from({ length: 25 }, () => ({
//       offsetX: (Math.random() - 0.5) * 1.5,
//       offsetY: (Math.random() - 0.5) * 1.5,
//       speed: Math.random() * 0.04 + 0.01,
//       scale: Math.random() * 0.15 + 0.05,
//       rotSpeedX: Math.random() * 0.05,
//       rotSpeedY: Math.random() * 0.05,
//     }));
//   });

//   useEffect(() => {
//     if (!isCanvasInView) return;

//     const handleMouseMove = (e: MouseEvent) => {
//       mouse.current.x = (e.clientX / window.innerWidth) * 2 - 1;
//       mouse.current.y = -(e.clientY / window.innerHeight) * 2 + 1;
//     };

//     window.addEventListener("mousemove", handleMouseMove);
//     return () => window.removeEventListener("mousemove", handleMouseMove);
//   }, [isCanvasInView]);

//   useFrame(() => {
//     const core = coreRef.current;
//     const dropsGroup = dropsGroupRef.current;

//     if (!core || !dropsGroup) return;

//     // Massive movement range so it can travel edge-to-edge freely
//     const targetX = mouse.current.x * 8;
//     const targetY = mouse.current.y * 5;

//     // Graceful interpolation to glide towards the cursor rather than snapping instantly
//     core.position.x += (targetX - core.position.x) * 0.06;
//     core.position.y += (targetY - core.position.y) * 0.06;

//     // Smooth rolling effect to match the graceful movement
//     const targetRotX = -mouse.current.y * 3;
//     const targetRotY = mouse.current.x * 3;

//     core.rotation.x += (targetRotX - core.rotation.x) * 0.06 + 0.005;
//     core.rotation.y += (targetRotY - core.rotation.y) * 0.06 + 0.01;

//     dropsGroup.children.forEach((drop, index) => {
//       const data = dropsData[index];

//       // Move down at the original graceful slow speed
//       drop.position.y -= data.speed;

//       // Slowly rotate
//       drop.rotation.x += data.rotSpeedX;
//       drop.rotation.y += data.rotSpeedY;

//       // Calculate vertical distance from the core center
//       const distanceY = core.position.y - drop.position.y;
//       const startBuddingDist = 1.0; // starts growing inside the core
//       const fullGrowthDist = 2.3; // fully grown and detached when it clears the core boundary

//       let scaleFactor = 0;
//       if (distanceY > startBuddingDist) {
//         scaleFactor = Math.min((distanceY - startBuddingDist) / (fullGrowthDist - startBuddingDist), 1);
//       }

//       // Smoothstep easing for organic scale growth
//       const easedScale = scaleFactor * scaleFactor * (3 - 2 * scaleFactor);
//       drop.scale.set(data.scale * easedScale, data.scale * easedScale, data.scale * easedScale);

//       // Resolve dynamic offset for Neumorphic width adjustments
//       const offsetX = drop.userData.offsetX !== undefined ? drop.userData.offsetX : data.offsetX;
//       const offsetZ = drop.userData.offsetZ !== undefined ? drop.userData.offsetZ : 0;

//       // Cling to the core's horizontal movement while budding
//       if (distanceY < fullGrowthDist) {
//         const attachFactor = 1 - (distanceY - startBuddingDist) / (fullGrowthDist - startBuddingDist);
//         const clampedAttach = Math.max(0, Math.min(1, attachFactor));
//         // Interpolate horizontal position towards core + offset
//         drop.position.x += (core.position.x + offsetX - drop.position.x) * clampedAttach * 0.15;
//         drop.position.z += (core.position.z + offsetZ - drop.position.z) * clampedAttach * 0.15;
//       }

//       // Reset when falling past the bottom boundary of the canvas
//       if (drop.position.y < -5) {
//         const radius = 2.1;
//         // Spans a very wide bottom hemisphere (almost equator to equator) for a wide rain effect
//         const angle = -Math.PI / 2 + (Math.random() - 0.5) * 2.4;
//         drop.userData.offsetX = Math.cos(angle) * radius * 0.95;
//         drop.userData.offsetZ = (Math.random() - 0.5) * 2.5;

//         drop.position.x = core.position.x + drop.userData.offsetX;
//         drop.position.y = core.position.y + Math.sin(angle) * radius * 0.95;
//         drop.position.z = core.position.z + drop.userData.offsetZ;
//       }
//     });
//   });

//   return (
//     <>
//       <mesh ref={coreRef}>
//         <sphereGeometry args={[2.1, 32, 32]} />
//         <MeshDistortMaterial
//           color={anomalyColor}
//           distort={0.3}
//           speed={1}
//           roughness={1}
//         />
//       </mesh>

//       <group ref={dropsGroupRef}>
//         {dropsData.map((data, i) => (
//           <mesh
//             key={i}
//             position={[0, -10, 0]}
//             scale={data.scale}
//             geometry={boxGeom}
//             material={boxMat}
//           />
//         ))}
//       </group>
//     </>
//   );
// }

// // eslint-disable-next-line @typescript-eslint/no-unused-vars
// function MechanicalArrow({ isCanvasInView }: { isCanvasInView: boolean }) {
//   const [isEmber, setIsEmber] = useState(false);
//   const [isNeumorphic, setIsNeumorphic] = useState(false);

//   useEffect(() => {
//     const checkTheme = () => {
//       setIsEmber(document.documentElement.classList.contains("theme-color"));
//       setIsNeumorphic(document.documentElement.classList.contains("theme-neumorphic"));
//     };
//     checkTheme();
//     const observer = new MutationObserver(checkTheme);
//     observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
//     return () => observer.disconnect();
//   }, []);

//   const coreRef = useRef<THREE.Group>(null);
//   const mouse = useRef({ x: 0, y: 0 });

//   let anomalyColor = "#ffffff";
//   if (isEmber) {
//     anomalyColor = "#FF3300";
//   } else if (isNeumorphic) {
//     anomalyColor = "#3d3426";
//   }

//   const boxGeom = useMemo(() => new THREE.BoxGeometry(1, 1, 1), []);
//   const boxMat = useMemo(() => new THREE.MeshBasicMaterial({ color: anomalyColor }), [anomalyColor]);

//   useEffect(() => {
//     return () => {
//       boxGeom.dispose();
//     };
//   }, [boxGeom]);

//   useEffect(() => {
//     return () => {
//       boxMat.dispose();
//     };
//   }, [boxMat]);

//   useEffect(() => {
//     if (!isCanvasInView) return;
//     const handleMouseMove = (e: MouseEvent) => {
//       mouse.current.x = (e.clientX / window.innerWidth) * 2 - 1;
//       mouse.current.y = -(e.clientY / window.innerHeight) * 2 + 1;
//     };
//     window.addEventListener("mousemove", handleMouseMove);
//     return () => window.removeEventListener("mousemove", handleMouseMove);
//   }, [isCanvasInView]);

//   useFrame(() => {
//     const core = coreRef.current;
//     if (!core) return;

//     const targetX = mouse.current.x * 8;
//     const targetY = mouse.current.y * 5;

//     // Graceful interpolation
//     core.position.x += (targetX - core.position.x) * 0.06;
//     core.position.y += (targetY - core.position.y) * 0.06;

//     const targetRotX = -mouse.current.y * 1.5;
//     const targetRotY = mouse.current.x * 1.5;

//     core.rotation.x += (targetRotX - core.rotation.x) * 0.06 + 0.005;
//     core.rotation.y += (targetRotY - core.rotation.y) * 0.06 + 0.01;
//   });

//   return (
//     <group ref={coreRef} rotation={[0, 0, -Math.PI / 4]}>
//       {/* Shaft */}
//       <mesh position={[0, -0.5, 0]} scale={[0.4, 6, 0.4]} geometry={boxGeom} material={boxMat} />
//       {/* Arrowhead Left Fin */}
//       <mesh position={[-0.8, 1.7, 0]} scale={[0.4, 2.5, 0.4]} rotation={[0, 0, Math.PI / 4]} geometry={boxGeom} material={boxMat} />
//       {/* Arrowhead Right Fin */}
//       <mesh position={[0.8, 1.7, 0]} scale={[0.4, 2.5, 0.4]} rotation={[0, 0, -Math.PI / 4]} geometry={boxGeom} material={boxMat} />

//       {/* Decorative floating mechanical bits */}
//       <mesh position={[-2, -3, 0]} scale={[0.3, 0.3, 0.3]} geometry={boxGeom} material={boxMat} />
//       <mesh position={[2, -2, 1]} scale={[0.4, 0.4, 0.4]} geometry={boxGeom} material={boxMat} />
//     </group>
//   );
// }

// // eslint-disable-next-line @typescript-eslint/no-unused-vars
// function BrutalCross({ isCanvasInView }: { isCanvasInView: boolean }) {
//   const [isEmber, setIsEmber] = useState(false);
//   const [isNeumorphic, setIsNeumorphic] = useState(false);

//   useEffect(() => {
//     const checkTheme = () => {
//       setIsEmber(document.documentElement.classList.contains("theme-color"));
//       setIsNeumorphic(document.documentElement.classList.contains("theme-neumorphic"));
//     };
//     checkTheme();
//     const observer = new MutationObserver(checkTheme);
//     observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
//     return () => observer.disconnect();
//   }, []);

//   const coreRef = useRef<THREE.Group>(null);
//   const mouse = useRef({ x: 0, y: 0 });

//   let anomalyColor = "#ffffff";
//   if (isEmber) {
//     anomalyColor = "#FF3300";
//   } else if (isNeumorphic) {
//     anomalyColor = "#3d3426";
//   }

//   const boxGeom = useMemo(() => new THREE.BoxGeometry(1, 1, 1), []);
//   const boxMat = useMemo(() => new THREE.MeshBasicMaterial({ color: anomalyColor }), [anomalyColor]);

//   useEffect(() => {
//     return () => {
//       boxGeom.dispose();
//     };
//   }, [boxGeom]);

//   useEffect(() => {
//     return () => {
//       boxMat.dispose();
//     };
//   }, [boxMat]);

//   useEffect(() => {
//     if (!isCanvasInView) return;
//     const handleMouseMove = (e: MouseEvent) => {
//       mouse.current.x = (e.clientX / window.innerWidth) * 2 - 1;
//       mouse.current.y = -(e.clientY / window.innerHeight) * 2 + 1;
//     };
//     window.addEventListener("mousemove", handleMouseMove);
//     return () => window.removeEventListener("mousemove", handleMouseMove);
//   }, [isCanvasInView]);

//   useFrame(() => {
//     const core = coreRef.current;
//     if (!core) return;

//     const targetX = mouse.current.x * 8;
//     const targetY = mouse.current.y * 5;

//     core.position.x += (targetX - core.position.x) * 0.06;
//     core.position.y += (targetY - core.position.y) * 0.06;

//     const targetRotX = -mouse.current.y * 1.5;
//     const targetRotY = mouse.current.x * 1.5;

//     core.rotation.x += (targetRotX - core.rotation.x) * 0.06 + 0.005;
//     core.rotation.y += (targetRotY - core.rotation.y) * 0.06 + 0.01;
//     core.rotation.z += 0.005; // Slow ambient spin
//   });

//   return (
//     <group ref={coreRef}>
//       <mesh position={[0, 0, 0]} scale={[1.2, 5, 1.2]} geometry={boxGeom} material={boxMat} />
//       <mesh position={[0, 0, 0]} scale={[5, 1.2, 1.2]} geometry={boxGeom} material={boxMat} />
//     </group>
//   );
// }

// // eslint-disable-next-line @typescript-eslint/no-unused-vars
// function WireframeMonolith({ isCanvasInView }: { isCanvasInView: boolean }) {
//   const [isEmber, setIsEmber] = useState(false);
//   const [isNeumorphic, setIsNeumorphic] = useState(false);

//   useEffect(() => {
//     const checkTheme = () => {
//       setIsEmber(document.documentElement.classList.contains("theme-color"));
//       setIsNeumorphic(document.documentElement.classList.contains("theme-neumorphic"));
//     };
//     checkTheme();
//     const observer = new MutationObserver(checkTheme);
//     observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
//     return () => observer.disconnect();
//   }, []);

//   const coreRef = useRef<THREE.Group>(null);
//   const innerRef = useRef<THREE.Mesh>(null);
//   const mouse = useRef({ x: 0, y: 0 });

//   let anomalyColor = "#ffffff";
//   if (isEmber) {
//     anomalyColor = "#FF3300";
//   } else if (isNeumorphic) {
//     anomalyColor = "#3d3426";
//   }

//   const boxGeom = useMemo(() => new THREE.BoxGeometry(1, 1, 1), []);
//   const wireMat = useMemo(() => new THREE.MeshBasicMaterial({ color: anomalyColor, wireframe: true }), [anomalyColor]);
//   const solidMat = useMemo(() => new THREE.MeshBasicMaterial({ color: anomalyColor }), [anomalyColor]);

//   useEffect(() => {
//     return () => {
//       boxGeom.dispose();
//     };
//   }, [boxGeom]);

//   useEffect(() => {
//     return () => {
//       wireMat.dispose();
//       solidMat.dispose();
//     };
//   }, [wireMat, solidMat]);

//   useEffect(() => {
//     if (!isCanvasInView) return;
//     const handleMouseMove = (e: MouseEvent) => {
//       mouse.current.x = (e.clientX / window.innerWidth) * 2 - 1;
//       mouse.current.y = -(e.clientY / window.innerHeight) * 2 + 1;
//     };
//     window.addEventListener("mousemove", handleMouseMove);
//     return () => window.removeEventListener("mousemove", handleMouseMove);
//   }, [isCanvasInView]);

//   useFrame(() => {
//     const core = coreRef.current;
//     const inner = innerRef.current;
//     if (!core || !inner) return;

//     const targetX = mouse.current.x * 8;
//     const targetY = mouse.current.y * 5;

//     core.position.x += (targetX - core.position.x) * 0.06;
//     core.position.y += (targetY - core.position.y) * 0.06;

//     const targetRotX = -mouse.current.y * 1.5;
//     const targetRotY = mouse.current.x * 1.5;

//     core.rotation.x += (targetRotX - core.rotation.x) * 0.06 + 0.005;
//     core.rotation.y += (targetRotY - core.rotation.y) * 0.06 + 0.01;

//     // Counter-rotate the inner solid core for a cool effect
//     inner.rotation.x -= 0.01;
//     inner.rotation.y += 0.015;
//   });

//   return (
//     <group ref={coreRef}>
//       <mesh scale={[4, 4, 4]} geometry={boxGeom} material={wireMat} />
//       <mesh ref={innerRef} scale={[1, 1, 1]} geometry={boxGeom} material={solidMat} />
//     </group>
//   );
// }

export default function CTA(t0) {
  const $ = _c(58);
  const {
    dict
  } = t0;
  const [isNeumorphic, setIsNeumorphic] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["arrow", "cross", "wireframe", "leak"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const anomalies = t1 as const;
  const [, setAnomalyIndex] = useState(1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const checkTheme = () => {
        setIsNeumorphic(document.documentElement.classList.contains("theme-neumorphic"));
      };
      checkTheme();
      const observer = new MutationObserver(checkTheme);
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["class"]
      });
      return () => observer.disconnect();
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const handleScroll = _temp;
  const ctaRef = useRef(null);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      margin: "0px 0px 0px 0px"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useInView(ctaRef, t4);
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setAnomalyIndex(prev => (prev + 1) % anomalies.length);
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = `relative w-full min-h-[100dvh] flex flex-col items-center justify-center py-16 px-6 md:px-12 lg:px-24 overflow-hidden border-t-8 border-b-8 border-black transition-colors duration-300 ${isNeumorphic ? "bg-white text-black" : "bg-black text-white"}`;
  const t7 = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg stroke='${isNeumorphic ? "%23a3b1c6" : "%23161616"}' stroke-width='6' fill='none' stroke-linecap='square' stroke-linejoin='miter'%3E%3Cline x1='25' y1='75' x2='72' y2='28' /%3E%3Cpolyline points='50,25 75,25 75,50' /%3E%3Cline x1='65' y1='5' x2='95' y2='35' /%3E%3C/g%3E%3C/svg%3E")`;
  let t8;
  if ($[5] !== t7) {
    t8 = <div className="absolute inset-0 z-0 pointer-events-none" style={{
      backgroundImage: t7,
      backgroundSize: "100px 100px"
    }} />;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute -top-8 -left-2 md:-top-16 md:-left-8 text-current font-black text-[10rem] md:text-[18rem] leading-none opacity-5 pointer-events-none select-none rtl:-left-auto rtl:-right-2 rtl:md:-right-8">"</div>;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  let t11;
  let t12;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 0,
      y: 20
    };
    t11 = {
      opacity: 1,
      y: 0
    };
    t12 = {
      once: true
    };
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
  } else {
    t10 = $[8];
    t11 = $[9];
    t12 = $[10];
  }
  const t13 = `text-4xl sm:text-5xl md:text-6xl lg:text-[4.5rem] xl:text-7xl font-black uppercase tracking-tighter leading-none relative z-10 p-4 quote-backdrop ${isNeumorphic ? "bg-white/90 text-black" : "bg-black/90 text-white"}`;
  const t14 = dict?.quote || "It's no use going back to yesterday, because I was a different person then.";
  let t15;
  if ($[11] !== t13 || $[12] !== t14) {
    t15 = <motion.blockquote initial={t10} whileInView={t11} viewport={t12} className={t13}>"{t14}"</motion.blockquote>;
    $[11] = t13;
    $[12] = t14;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  let t17;
  let t18;
  let t19;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      opacity: 0
    };
    t17 = {
      opacity: 1
    };
    t18 = {
      once: true
    };
    t19 = {
      delay: 0.3
    };
    $[14] = t16;
    $[15] = t17;
    $[16] = t18;
    $[17] = t19;
  } else {
    t16 = $[14];
    t17 = $[15];
    t18 = $[16];
    t19 = $[17];
  }
  const t20 = `flex items-center gap-4 mt-8 relative z-10 p-4 max-w-max quote-backdrop ${isNeumorphic ? "bg-white/90" : "bg-black/90"}`;
  const t21 = `h-2 w-8 sm:w-16 md:w-24 shrink-0 ${isNeumorphic ? "bg-black" : "bg-white"}`;
  let t22;
  if ($[18] !== t21) {
    t22 = <div className={t21} />;
    $[18] = t21;
    $[19] = t22;
  } else {
    t22 = $[19];
  }
  const t23 = `text-[10px] sm:text-sm md:text-lg font-bold tracking-widest uppercase whitespace-nowrap pe-1 ${isNeumorphic ? "text-zinc-600" : "text-zinc-400"}`;
  const t24 = dict?.attribution || "[ Alice in Wonderland / Lewis Carroll ]";
  let t25;
  if ($[20] !== t23 || $[21] !== t24) {
    t25 = <span className={t23}>{t24}</span>;
    $[20] = t23;
    $[21] = t24;
    $[22] = t25;
  } else {
    t25 = $[22];
  }
  let t26;
  if ($[23] !== t20 || $[24] !== t22 || $[25] !== t25) {
    t26 = <motion.div initial={t16} whileInView={t17} viewport={t18} transition={t19} className={t20}>{t22}{t25}</motion.div>;
    $[23] = t20;
    $[24] = t22;
    $[25] = t25;
    $[26] = t26;
  } else {
    t26 = $[26];
  }
  let t27;
  if ($[27] !== t15 || $[28] !== t26) {
    t27 = <div className="flex-1 flex flex-col relative w-full">{t9}{t15}{t26}</div>;
    $[27] = t15;
    $[28] = t26;
    $[29] = t27;
  } else {
    t27 = $[29];
  }
  let t28;
  let t29;
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      opacity: 0,
      y: 40
    };
    t29 = {
      opacity: 1,
      y: 0
    };
    t30 = {
      once: true
    };
    $[30] = t28;
    $[31] = t29;
    $[32] = t30;
  } else {
    t28 = $[30];
    t29 = $[31];
    t30 = $[32];
  }
  const t31 = `text-center flex flex-col items-center gap-6 pointer-events-auto w-full static-card-container ${isNeumorphic ? "brutalist-container bg-white text-black border-4 md:border-8 border-black brutalist-shadow p-8 md:p-12" : "brutalist-container-dark md:border-8 p-8 md:p-12"}`;
  const t32 = dict?.title || "Ready to build?";
  let t33;
  if ($[33] !== t32) {
    t33 = <h2 className="text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-none">{t32}</h2>;
    $[33] = t32;
    $[34] = t33;
  } else {
    t33 = $[34];
  }
  const t34 = `text-base md:text-lg lg:text-xl font-bold uppercase ${isNeumorphic ? "text-zinc-600" : "text-zinc-400"}`;
  const t35 = dict?.description || "Open for freelance projects and full-time roles.";
  let t36;
  if ($[35] !== t34 || $[36] !== t35) {
    t36 = <p className={t34}>{t35}</p>;
    $[35] = t34;
    $[36] = t35;
    $[37] = t36;
  } else {
    t36 = $[37];
  }
  const t37 = `group/btn relative inline-flex items-center justify-center px-8 py-4 text-lg md:text-xl font-black uppercase tracking-widest border-4 mt-4 ${isNeumorphic ? "bg-black text-white border-black" : "bg-white text-black border-white"}`;
  const t38 = dict?.button || "Get in touch";
  let t39;
  if ($[38] !== t38) {
    t39 = <span>{t38}</span>;
    $[38] = t38;
    $[39] = t39;
  } else {
    t39 = $[39];
  }
  const t40 = `ms-3 w-6 h-6 transition-transform rtl:-scale-x-100 ${isHovered ? "[animation:arrow-snap-sequence_0.8s_ease-in-out_forwards]" : ""}`;
  let t41;
  if ($[40] !== t40) {
    t41 = <ArrowDownRight className={t40} />;
    $[40] = t40;
    $[41] = t41;
  } else {
    t41 = $[41];
  }
  let t42;
  if ($[42] !== t37 || $[43] !== t39 || $[44] !== t41) {
    t42 = <RippleButton as={Link} href="#contact" onClick={handleScroll} onHoverChange={setIsHovered} className={t37}>{t39}{t41}</RippleButton>;
    $[42] = t37;
    $[43] = t39;
    $[44] = t41;
    $[45] = t42;
  } else {
    t42 = $[45];
  }
  let t43;
  if ($[46] !== t31 || $[47] !== t33 || $[48] !== t36 || $[49] !== t42) {
    t43 = <motion.div initial={t28} whileInView={t29} viewport={t30} className="w-full xl:w-[29.35rem] shrink-0"><div className={t31}>{t33}{t36}{t42}</div></motion.div>;
    $[46] = t31;
    $[47] = t33;
    $[48] = t36;
    $[49] = t42;
    $[50] = t43;
  } else {
    t43 = $[50];
  }
  let t44;
  if ($[51] !== t27 || $[52] !== t43) {
    t44 = <div className="relative z-10 w-full max-w-[75rem] mx-auto flex flex-col xl:flex-row items-center justify-between gap-16 pointer-events-none">{t27}{t43}</div>;
    $[51] = t27;
    $[52] = t43;
    $[53] = t44;
  } else {
    t44 = $[53];
  }
  let t45;
  if ($[54] !== t44 || $[55] !== t6 || $[56] !== t8) {
    t45 = <section ref={ctaRef} onClick={t5} className={t6}>{t8}{t44}</section>;
    $[54] = t44;
    $[55] = t6;
    $[56] = t8;
    $[57] = t45;
  } else {
    t45 = $[57];
  }
  return t45;
}
function _temp(e) {
  e.preventDefault();
  const contactSection = document.getElementById("contact");
  if (contactSection) {
    contactSection.scrollIntoView({
      behavior: "smooth"
    });
    const currentLocale = window.location.pathname.split("/")[1] || "en";
    window.history.pushState(null, "", `/${currentLocale}#contact`);
  }
}